import React from "react";

const DotsHeaderM = () => (
  <svg width="181" height="518" viewBox="0 0 181 518" fill="none" xmlns="http://www.w3.org/2000/svg">
<g style={{mixBlendMode: "difference"}}>
<path className="st0" d="M469.9,511.3c1.4,1.7,1.1,4.2-0.7,5.6l0,0c-1.7,1.4-4.2,1.1-5.6-0.7c-1.4-1.7-1.1-4.2,0.7-5.6l0,0
  C466.1,509.3,468.6,509.6,469.9,511.3z" fill="#FFFFFF" />
<path className="st0" d="M494.1,489.2c-1.6-1.5-1.7-4-0.2-5.7l0,0c1.5-1.6,4-1.7,5.7-0.2c1.6,1.5,1.7,4,0.2,5.7l0,0
  C498.2,490.7,495.7,490.8,494.1,489.2z" fill="#FFFFFF" />
<path className="st0" d="M520.2,458c-1.8-1.3-2.3-3.8-1-5.6l0,0c1.3-1.8,3.8-2.3,5.6-1s2.3,3.8,1,5.6l0,0
  C524.5,458.8,522,459.3,520.2,458z" fill="#FFFFFF" />
<path className="st0" d="M541.6,423.4c-2-1-2.8-3.4-1.8-5.4l0,0c1-2,3.4-2.8,5.4-1.8s2.8,3.4,1.8,5.4l0,0
  C546,423.6,543.6,424.4,541.6,423.4z" fill="#FFFFFF" />
<path className="st0" d="M557.8,386c-2.1-0.7-3.2-3-2.5-5.1l0,0c0.7-2.1,3-3.2,5.1-2.5s3.2,3,2.5,5.1l0,0
  C562.2,385.6,559.9,386.7,557.8,386z" fill="#FFFFFF" />
<path className="st0" d="M568.6,346.8c-2.2-0.4-3.6-2.5-3.2-4.7l0,0c0.4-2.2,2.5-3.6,4.7-3.2s3.6,2.5,3.2,4.7l0,0
  C572.9,345.7,570.8,347.2,568.6,346.8z" fill="#FFFFFF" />
<path className="st0" d="M573.9,306.4c-2.2-0.1-3.9-2-3.8-4.2l0,0c0.1-2.2,2-3.9,4.2-3.8s3.9,2,3.8,4.2l0,0
  C578,304.8,576.1,306.5,573.9,306.4z" fill="#FFFFFF" />
<path className="st0" d="M573.6,265.7c-2.2,0.2-4.1-1.4-4.4-3.6l0,0c-0.2-2.2,1.4-4.1,3.6-4.4s4.1,1.4,4.4,3.6l0,0
  C577.4,263.5,575.8,265.5,573.6,265.7z" fill="#FFFFFF" />
<path className="st0" d="M567.5,225.4c-2.1,0.5-4.3-0.8-4.8-3l0,0c-0.5-2.1,0.8-4.3,3-4.8c2.1-0.5,4.3,0.8,4.8,3l0,0
  C571,222.7,569.7,224.9,567.5,225.4z" fill="#FFFFFF" />
<path className="st0" d="M555.9,186.4c-2.1,0.8-4.4-0.2-5.2-2.2l0,0c-0.8-2.1,0.2-4.4,2.2-5.2c2.1-0.8,4.4,0.2,5.2,2.2l0,0
  C558.9,183.2,557.9,185.6,555.9,186.4z" fill="#FFFFFF" />
<path className="st0" d="M538.7,149.5c-1.9,1.1-4.4,0.4-5.5-1.5l0,0c-1.1-1.9-0.4-4.4,1.5-5.5s4.4-0.4,5.5,1.5l0,0
  C541.3,145.9,540.6,148.4,538.7,149.5z" fill="#FFFFFF" />
<path className="st0" d="M516.3,115.4c-1.7,1.4-4.2,1.1-5.6-0.7l0,0c-1.4-1.7-1.1-4.2,0.7-5.6c1.7-1.4,4.2-1.1,5.6,0.7l0,0
  C518.3,111.5,518,114.1,516.3,115.4z" fill="#FFFFFF" />
<path className="st0" d="M489.2,85c-1.5,1.6-4,1.7-5.7,0.2l0,0c-1.6-1.5-1.7-4-0.2-5.7c1.5-1.6,4-1.7,5.7-0.2l0,0
  C490.7,80.9,490.8,83.4,489.2,85z" fill="#FFFFFF" />
<path className="st0" d="M458,58.9c-1.3,1.8-3.8,2.3-5.6,1l0,0c-1.8-1.3-2.3-3.8-1-5.6s3.8-2.3,5.6-1l0,0C458.8,54.6,459.3,57,458,58.9z
  " fill="#FFFFFF" />
<path className="st0" d="M423.4,37.5c-1,2-3.4,2.8-5.4,1.8l0,0c-2-1-2.8-3.4-1.8-5.4s3.4-2.8,5.4-1.8l0,0
  C423.6,33.1,424.4,35.5,423.4,37.5z" fill="#FFFFFF" />
<path className="st0" d="M386,21.3c-0.7,2.1-3,3.2-5.1,2.5l0,0c-2.1-0.7-3.2-3-2.5-5.1s3-3.2,5.1-2.5l0,0
  C385.6,16.9,386.7,19.2,386,21.3z" fill="#FFFFFF" />
<path className="st0" d="M346.8,10.4c-0.4,2.2-2.5,3.6-4.7,3.2l0,0c-2.2-0.4-3.6-2.5-3.2-4.7s2.5-3.6,4.7-3.2l0,0
  C345.7,6.2,347.2,8.3,346.8,10.4z" fill="#FFFFFF" />
<path className="st0" d="M306.4,5.2c-0.1,2.2-2,3.9-4.2,3.8l0,0c-2.2-0.1-3.9-2-3.8-4.2s2-3.9,4.2-3.8l0,0C304.8,1.1,306.5,3,306.4,5.2z
  " fill="#FFFFFF" />
<path className="st0" d="M265.7,5.5c0.2,2.2-1.4,4.1-3.6,4.4l0,0c-2.2,0.2-4.1-1.4-4.4-3.6c-0.2-2.2,1.4-4.1,3.6-4.4l0,0
  C263.5,1.7,265.5,3.3,265.7,5.5z" fill="#FFFFFF" />
<path className="st0" d="M225.4,11.5c0.5,2.1-0.8,4.3-3,4.8l0,0c-2.1,0.5-4.3-0.8-4.8-3s0.8-4.3,3-4.8l0,0
  C222.7,8.1,224.9,9.4,225.4,11.5z" fill="#FFFFFF" />
<path className="st0" d="M186.4,23.2c0.8,2.1-0.2,4.4-2.2,5.2l0,0c-2.1,0.8-4.4-0.2-5.2-2.2c-0.8-2.1,0.2-4.4,2.2-5.2l0,0
  C183.2,20.2,185.6,21.2,186.4,23.2z" fill="#FFFFFF" />
<path className="st0" d="M149.5,40.4c1.1,1.9,0.4,4.4-1.5,5.5l0,0c-1.9,1.1-4.4,0.4-5.5-1.5s-0.4-4.4,1.5-5.5l0,0
  C145.9,37.8,148.4,38.5,149.5,40.4z" fill="#FFFFFF" />
<path className="st0" d="M115.4,62.8c1.4,1.7,1.1,4.2-0.7,5.6l0,0c-1.7,1.4-4.2,1.1-5.6-0.7c-1.4-1.7-1.1-4.2,0.7-5.6l0,0
  C111.5,60.7,114.1,61,115.4,62.8z" fill="#FFFFFF" />
<path className="st0" d="M79.5,95.7c-1.6-1.5-1.7-4-0.2-5.7l0,0c1.5-1.6,4-1.7,5.7-0.2c1.6,1.5,1.7,4,0.2,5.7l0,0
  C83.7,97.1,81.1,97.2,79.5,95.7z" fill="#FFFFFF" />
<path className="st0" d="M54.3,127.6c-1.8-1.3-2.3-3.8-1-5.6l0,0c1.3-1.8,3.8-2.3,5.6-1s2.3,3.8,1,5.6l0,0
  C58.6,128.5,56.1,128.9,54.3,127.6z" fill="#FFFFFF" />
<path className="st0" d="M33.9,162.9c-2-1-2.8-3.4-1.8-5.4l0,0c1-2,3.4-2.8,5.4-1.8s2.8,3.4,1.8,5.4l0,0
  C38.3,163.1,35.9,163.9,33.9,162.9z" fill="#FFFFFF" />
<path className="st0" d="M18.7,200.7c-2.1-0.7-3.2-3-2.5-5.1l0,0c0.7-2.1,3-3.2,5.1-2.5s3.2,3,2.5,5.1l0,0
  C23.1,200.3,20.8,201.4,18.7,200.7z" fill="#FFFFFF" />
<path className="st0" d="M9,240.2c-2.2-0.4-3.6-2.5-3.2-4.7l0,0c0.4-2.2,2.5-3.6,4.7-3.2c2.2,0.4,3.6,2.5,3.2,4.7l0,0
  C13.2,239.2,11.1,240.6,9,240.2z" fill="#FFFFFF" />
<path className="st0" d="M4.8,280.7c-2.2-0.1-3.9-2-3.8-4.2l0,0c0.1-2.2,2-3.9,4.2-3.8s3.9,2,3.8,4.2l0,0C8.9,279.1,7,280.8,4.8,280.7z"
   fill="#FFFFFF" />
<path className="st0" d="M6.2,321.4c-2.2,0.2-4.1-1.4-4.4-3.6l0,0c-0.2-2.2,1.4-4.1,3.6-4.4c2.2-0.2,4.1,1.4,4.4,3.6l0,0
  C10.1,319.3,8.4,321.2,6.2,321.4z" fill="#FFFFFF" />
<path className="st0" d="M13.4,361.5c-2.1,0.5-4.3-0.8-4.8-3l0,0c-0.5-2.1,0.8-4.3,3-4.8c2.1-0.5,4.3,0.8,4.8,3l0,0
  C16.9,358.8,15.5,361,13.4,361.5z" fill="#FFFFFF" />
<path className="st0" d="M26.2,400.2c-2.1,0.8-4.4-0.2-5.2-2.2l0,0c-0.8-2.1,0.2-4.4,2.2-5.2c2.1-0.8,4.4,0.2,5.2,2.2l0,0
  C29.2,397,28.2,399.3,26.2,400.2z" fill="#FFFFFF" />
<path className="st0" d="M44.4,436.6c-1.9,1.1-4.4,0.4-5.5-1.5l0,0c-1.1-1.9-0.4-4.4,1.5-5.5s4.4-0.4,5.5,1.5l0,0
  C47,433,46.3,435.5,44.4,436.6z" fill="#FFFFFF" />
<path className="st0" d="M67.7,469.9c-1.7,1.4-4.2,1.1-5.6-0.7l0,0c-1.4-1.7-1.1-4.2,0.7-5.6c1.7-1.4,4.2-1.1,5.6,0.7l0,0
  C69.8,466.1,69.5,468.6,67.7,469.9z" fill="#FFFFFF" />
</g>
</svg>
);

export default DotsHeaderM;
